/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { gnoment } from 'shared-ui/gnoment';
import { Durations } from '../constants';
import { getDivisionFromPeriods } from './date_time_utils';

export const getDuration = (duration = '') => Durations[duration.replace(/,.*/, '')];
export const getDurationOptions = (duration = '') =>
    duration.replace(/^.*?,/, '').split(',');
export const durationLength = (duration = '') => getDuration(duration).validLength;

export const validToDate = (startDate, passType) => {
    const duration = getDuration(passType.duration);
    const durationOptions = getDurationOptions(passType.duration);
    const division = getDivisionFromPeriods(passType.periods, gnoment(startDate));

    const addN =
        duration.days === 365
            ? 1
            : passType.duration === '6-month'
              ? duration.days / 30
              : duration.days > 0
                ? duration.days - 1
                : duration.days; // days = 1, means same day. days = 3, means today + other 2 days... and so on
    const addUnit =
        duration.days === 365
            ? 'year'
            : passType.duration === '6-month'
              ? 'month'
              : 'days';
    const cloneDate = gnoment(startDate).add(addN, addUnit).format('YYYY-MM-DD');
    const endDate = gnoment(cloneDate);

    if (!duration.endEndOfMonth) {
        // division.ends_at is in 'MM-DD' format (e.g., '12-31')
        // We need to construct a full date by prepending the year from startDate
        // to create a valid ISO 8601 date string for gnoment parsing
        const currentYear = gnoment(startDate).year();
        const endOfSeason = gnoment(`${currentYear}-${division.ends_at}`, 'YYYY-MM-DD');

        // If season end is before start date, it must be next year
        // This handles seasons that cross year boundaries (e.g., Dec 2024 to Mar 2025)
        if (endOfSeason.isBefore(gnoment(startDate), 'day')) {
            endOfSeason.add(1, 'year');
        }

        if (durationOptions.includes('limit-to-season') && endDate.isAfter(endOfSeason)) {
            return endOfSeason;
        }
        return endDate;
    }
    const cloneEndDate = endDate.endOf('month').format();
    const endOfMonth = gnoment(cloneEndDate);
    return endOfMonth;
};
